// export const BETSLIP_BASE_URL = process.env.NODE_ENV === 'production' ? 'https://globalapi.geoffbanks.bet': 'https://globalapi.geoffbanks.bet' //'https://geoffbanks-api-dev2.azurewebsites.net'
// DEV
// export const BETSLIP_BASE_URL = 'https://dev-globalapi.geoffbanks.bet' 
// PROD
// export const BETSLIP_BASE_URL = 'https://globalapi.geoffbanks.bet' 
export const BETSLIP_BASE_URL = process.env.VUE_APP_GLOBAL_API
